export const GET_HOTEL_LIST = "GET_HOTEL_LIST";
export const MODIFY_HOTEL_LIST_SUCCESS = "MODIFY_HOTEL_LIST_SUCCESS";
export const API_ERROR = "API_ERROR";
export const GET_PREFERRED_HOTEL_LIST = "GET_PREFERRED_HOTEL_LIST";
export const GET_BLOCKED_HOTEL_LIST = "GET_BLOCKED_HOTEL_LIST";
export const MODIFY_BLOCKED_HOTEL_LIST_SUCCESS =
    "MODIFY_BLOCKED_HOTEL_LIST_SUCCESS";
export const FETCH_SELECTED_HOTEL_ID = "FETCH_SELECTED_HOTEL_ID";
export const FETCH_BLOCKED_HOTEL_ID = "FETCH_BLOCKED_HOTEL_ID";
